// ==================== Start Product Slider ====================
const createProductSlider = function() {
  var sliderMedia = new KeenSlider(".product-media__gallery--slider",
    {
      breakpoints: {
        '(max-width: 749px)': {
          slides: {
            perView: 1,
            spacing: 0,
          }
        },
        '(min-width: 750px)': {
          disabled: true,
        }
      },
      slideChanged() {
        sliderDotsAnimation();
      },
      updated() {
        sliderDotsAnimation();
      }
    },
    [navigation]
  )
}

document.addEventListener('DOMContentLoaded', createProductSlider);
// ==================== End Product Slider ====================

// ==================== Start slider dots animation ====================
// Start helper functions
const createDotBackground = function() {
  const dots = document.querySelector('.product-media__gallery .dots');
  let dotBackground = dots.querySelector('.dot__background');
  if (dotBackground) return;
  dotBackground =  document.createElement('span');
  dotBackground.classList.add('dot__background');
  dots.insertAdjacentElement('beforeend', dotBackground);
}

const updateDotBackground = function() {
  const dots = document.querySelector('.product-media__gallery .dots');
  const dotChildren = dots.querySelectorAll('.dot');
  const dotBackground = dots.querySelector('.dot__background');

  dotChildren.forEach(dot => {
    if (dot.classList.contains('dot--active')) {
      dotBackground.style.width = `${parseInt(getComputedStyle(dot).width)}px`;
      dotBackground.style.left = `${dot.offsetLeft}px`;
    }
  })

  if (!dotBackground.classList.contains('animate')) {
    setTimeout(() => {
      dotBackground.classList.add('animate');
    }, 300);
  }
}
// End helper functions

const sliderDotsAnimation = function() {
  // 1. Create dotBackground element
  createDotBackground();

  // 2. Update dotBackground
  updateDotBackground();
}

document.addEventListener('DOMContentLoaded', sliderDotsAnimation);
// ==================== End slider dots animation ====================

// ==================== Start VariantRadios Class ====================
class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.form = this.closest('.product-form');
    this.isBundleBuilder = this.form?.classList.contains('product-form--bundle-builder') ? true : false;
    this.bundleBuilderEl = this.isBundleBuilder ? this.closest('.bundle-builder') : '';
    this.multiAdd = this.form?.classList.contains('multi-add') ? true : false;
  }

  onVariantChange(e) {
    this.getSelectedOptions();
    this.getSelectedVariant();
    if(this.currentVariant && !this.multiAdd) {
      this.updateURL();
      this.updateFormID();
      this.updateProductInfo(e);
    }
    if (this.isBundleBuilder ) {
      this.updateBundleBuilder();
    }
    if (this.multiAdd) {
      this.updateMultiAdd();
    }
  }

  getSelectedOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.js-product-form-option'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  getVariantJSON() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getSelectedVariant() {
    this.currentVariant = this.getVariantJSON().find(variant => {
      const findings = !variant.options.map((option, index) => {
        return option === this.options[index];
      }).includes(false);

      if(findings) return variant;
    });
  }

  updateURL() {
    if(!this.currentVariant) return;

    if (!this.isBundleBuilder) {
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updateFormID() {
    const formInput = this.form.querySelector('input[name="id"]');
    formInput.value = this.currentVariant.id;
  }

  updateProductInfo(e) {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then(response => response.text())
    .then(responseText => {
      const idPrice = `price-${this.dataset.section}`;
      const idMedia = `media-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const oldPriceDesktop = document.querySelector('.product-info-above-description-desktop').querySelector(`#${idPrice}`);
      const newPriceDesktop = html.querySelector('.product-info-above-description-desktop').querySelector(`#${idPrice}`);
      const oldPriceMobile = document.querySelector('.product-info-above-description-mobile').querySelector(`#${idPrice}`);
      const newPriceMobile = html.querySelector('.product-info-above-description-mobile').querySelector(`#${idPrice}`);
      const oldAfterpay = document.querySelector('.product__afterpay');
      const newAfterpay = html.querySelector('.product__afterpay');
      const oldProductMedia = document.getElementById(idMedia);
      const newProductMedia = html.getElementById(idMedia);
      const currentVariantColor = this.form.querySelector('.option-heading__current-color');
      const oldCTA = this.form.querySelector('.product-form__cta');
      const newCTA= html.querySelector('.product-form__cta');
      const oldPreorderModal = document.querySelector('.preorder-confirmation-modal');
      const newPreorderModal = html.querySelector('.preorder-confirmation-modal');
      const oldDetailsTab = document.querySelector('.product-tab.tab-the-details .product-tab__content');
      const newDetailsTab = html.querySelector('.product-tab.tab-the-details .product-tab__content');
      const oldModelInfoDesktop = document.querySelector('.model-info--desktop');
      const newModelInfoDesktop = html.querySelector('.model-info--desktop');
      const oldFeaturedImage = document.querySelector('.product-media__gallery--slider .keen-slider__slide:first-child img');
      const newFeaturedImage = html.querySelector('.product-media__gallery--slider .keen-slider__slide:first-child img');
      const oldOptionHeadingColor = this.form.querySelector('.option-heading--color');
      const newOptionHeadingColor = html.querySelector('.option-heading--color');
      const oldDescription = document.querySelector('.product-description');
      const newDescription = html.querySelector('.product-description');
      const oldDescriptionAll = document.querySelectorAll('.js-product-description');
      
      // Update Price
      if (!this.isBundleBuilder) {
        if (oldPriceDesktop && newPriceDesktop) oldPriceDesktop.innerHTML = newPriceDesktop.innerHTML;
        if (oldPriceMobile && newPriceMobile) oldPriceMobile.innerHTML = newPriceMobile.innerHTML;
        if (oldAfterpay && newAfterpay) oldAfterpay.innerHTML = newAfterpay.innerHTML;
      }
      
      // Update CTA buttons
      if (oldCTA && newCTA) oldCTA.innerHTML = newCTA.innerHTML;
      addToCartBtnFunction();

      // Update Preorder Modal
      if (!this.isBundleBuilder) {
        if (oldPreorderModal && newPreorderModal) oldPreorderModal.innerHTML = newPreorderModal.innerHTML;
        preorderFunction();
      }

      // Update custom color details
      if (!this.isBundleBuilder) {
        // Update description
        if (oldDescription && newDescription) {
          oldDescriptionAll.forEach(el => el.innerHTML = newDescription.innerHTML);
        }

        if (oldDetailsTab && newDetailsTab) oldDetailsTab.innerHTML = newDetailsTab.innerHTML;
        productDimensions();
        learnMoreFunction();
        micronChart();
        micronModalFunction();
      }

      if (oldFeaturedImage.dataset.id !== newFeaturedImage.dataset.id) {
        // Update Media
        if (oldProductMedia && newProductMedia) {
          oldProductMedia.innerHTML = newProductMedia.innerHTML;
          this.recreateSlider();
          sliderDotsAnimation();
        }

        // Enable Image Zoom
        featuredImagesZoom();

        // Update Current Variant Color
        if (currentVariantColor) {
          currentVariantColor.innerHTML = this.currentVariant.option1;
        }

        // Lazyload Video
        videoObserverFunctionality();

        // Model Info - Desktop
        if (oldModelInfoDesktop && newModelInfoDesktop) {
          oldModelInfoDesktop.innerHTML = newModelInfoDesktop.innerHTML;
        } else {
          oldModelInfoDesktop.innerHTML = '';
        }

        // Model Info - Mobile
        modelInfoMobile();
      }

      // check Available Options
      this.checkAvailableOptions(e, html);

      // Hide BIS hidden options
      hideBIShiddenOptions();

      // Select a Size
      selectASizeBtnClick();
      
      if (!this.isBundleBuilder) {
        if (this.form.classList.contains('product-form--size-selected')) {
          this.form.classList.add('product-info-updated');
        }
      }

      // Customer Images Section
      // customerImgesFunction();

      // The Fit
      checkTheFitContent();
      adjustActiveProductTabHeight();

      // Option heading - color
      if (oldOptionHeadingColor && newOptionHeadingColor) oldOptionHeadingColor.innerHTML = newOptionHeadingColor.innerHTML;
    })
  }

  recreateSlider() {
    createProductSlider();
  }

  checkAvailableOptions(e, html) {
    if (!e) return;
    // When 'Color' or 'Size' is clicked
    if (e.target.attributes.option.nodeValue === 'Color' || e.target.attributes.option.nodeValue === 'Size') {
      const form = e.target.closest('.product-form');
      const allInputs = form.querySelectorAll('input');
      const selectedColorVariants = this.getVariantJSON().filter(variant => {
        const currentSelectedColor = html.querySelector('.product-form input[option="Color"][checked]').value;
        return variant.option1 === currentSelectedColor;
      });
      const inseamInputs = form.querySelectorAll('input[option="Inseam"]');
      const sizeInputs = form.querySelectorAll('input[option="Size"]');
      const notifyMeLink = document.querySelector('.info__notify-me');

      // 1- Reset
      allInputs.forEach(input => {
        input.classList.remove('disabled');
        input.setAttribute('data-counter', 0);
      });
      if (notifyMeLink) notifyMeLink.classList.remove('active');


      // 2- Add 'disabled' class to out of stock options
      selectedColorVariants.forEach(variant => {
        if (!variant.available) {

          // ========== If Size Only ==========
          if (variant.option2 && !variant.option3) this.checkSizesOnly(sizeInputs, variant)

          // ========== If Size & Inseam ==========
          if((variant.option2 && variant.option3)) this.checkSizesAndInseam(sizeInputs, inseamInputs, variant, selectedColorVariants, html)
        }
      });

      // 3- Notify Me Link - If at lease there's one variant OOS
      if (selectedColorVariants.some(variant => !variant.available)) {
        if (notifyMeLink) notifyMeLink.classList.add('active');
      }
    }
  }

  checkSizesOnly(sizeInputs, variant) {
    sizeInputs.forEach(input => {
      if (variant.option2 === input.value) input.classList.add('disabled');
    })
  }

  checkSizesAndInseam(sizeInputs, inseamInputs, variant, selectedColorVariants, html) {
    // ===== First ===== Disable Size Option if all Inseams are not available
    sizeInputs.forEach((inputSize) => {
      if (variant.option2 === inputSize.value) inputSize.setAttribute('data-counter', `${Number(inputSize.getAttribute('data-counter')) + 1}`);

      // If the 'data-counter' value = the number of Inseam Inputs, means all inseams are not available for this size
      // We can now disable this size
      if (Number(inputSize.getAttribute('data-counter')) ===  inseamInputs.length) inputSize.classList.add('disabled')
    })

    // ===== Second ===== Disable OOS Inseam Options
    // 1- Get Current Checked Size
    const currentSize = html.querySelector('.product-form input[option="Size"][checked]');

    // 2- Get all variants with the same checked size
    // 3- If variant is not available, disable the inseam option
    selectedColorVariants.forEach(el => {
      if (el.option2 === currentSize.value && !el.available) {
        inseamInputs.forEach((inputInseam) => {
          if (el.option3 === inputInseam.value) inputInseam.classList.add('disabled')
        })
      }
    })
  }

  updateBundleBuilder() {
    // 1. Check if current variant is available
    const confirmBtn = this.form.querySelector('.bundle-builder__confirm');
    const bundleBuilderATC = this.bundleBuilderEl.querySelector('.bundle-builder-add-to-cart');
    const soldOutEl = this.form.querySelector('.bundle-builder__sold-out');
    const bundleBuilderRowHeaders = this.bundleBuilderEl.querySelectorAll('.bundle-builder-row__header');
    const thisRow = this.form.closest('.bundle-builder-row');
    const bundleBuilderStepHeaders = document.querySelectorAll('.bundle-builder-step__header');

    if (!this.currentVariant.available) {
      // 1. Restrict this row
      thisRow.classList.add('restricted');

      // 2. Restrict all headers
      bundleBuilderRowHeaders.forEach(el => el.classList.add('restricted'));

      // 3. Restrict confirm button
      confirmBtn.classList.add('restricted');

      // 4. Restrict ATC button
      bundleBuilderATC.classList.add('restricted');

      // 5. Show sold out
      soldOutEl.classList.remove('hidden');

      // 6. Adjust row height
      thisRow.heightAnimation();

      // 6. Disable Step heading
      if (bundleBuilderStepHeaders.length > 0) {
        bundleBuilderStepHeaders.forEach(el => el.classList.add('restricted'));
      }
    } else {
      thisRow.classList.remove('restricted');
      bundleBuilderRowHeaders.forEach(el => el.classList.remove('restricted'));
      confirmBtn.classList.remove('restricted');
      bundleBuilderATC.classList.remove('restricted');
      soldOutEl.classList.add('hidden');
      thisRow.heightAnimation();
      if (bundleBuilderStepHeaders.length > 0) {
        bundleBuilderStepHeaders.forEach(el => el.classList.remove('restricted'));
      }
    }

    // 2. Show selected variant title
    const selectedVariantEl = this.form.closest('.bundle-builder-row').querySelector('.bundle-builder-row__selected-variant');
    let selectedVariantTitle;
    
    setTimeout(() => {
      const selectedStyle = this.form.closest('.bundle-builder-row').querySelector('.style-icon input[type="radio"]:checked');

      if (selectedStyle) {
        const styleTitle = selectedStyle.closest('.style-icon').querySelector('.style-icon__title').textContent;
        selectedVariantTitle = `${styleTitle} / ${this.currentVariant.title}`;
      } else {
        selectedVariantTitle = this.currentVariant.title;
      }

      selectedVariantEl.textContent = selectedVariantTitle;
    }, 300);
  }

  updateMultiAdd() {
    this.getAvailableOptions();
    this.getAvailableVariants();
    this.addVariantsInfo();
    this.resetQuantity();
  }

  getAvailableOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.js-product-form-option'));
    let currentSize;
    let allColors = [];
    let availableOptions = [];
    let availableOptionsArray = [];
    let arraySize = 2;

    fieldsets.forEach(fieldset => {
      const inputs = fieldset.querySelectorAll('input[type="radio"]');
      inputs.forEach(input => {
        if (input.getAttribute('option') === 'Size' || input.getAttribute('option') === 'size') { 
          if (input.checked) currentSize = input.value;
        } else if (input.getAttribute('option') === 'Color' || input.getAttribute('option') === 'color') { 
          allColors.push(input.value);
        }
      })
    })

    allColors.forEach(color => {
      availableOptions.push(color, currentSize);
    })

    for (let i = 0; i < availableOptions.length; i += arraySize) {
      availableOptionsArray.push(availableOptions.slice(i, i + arraySize));
    }

    return availableOptionsArray;
  }

  getAvailableVariants() {
    const availableOptionsArray = this.getAvailableOptions();
    let availableVariantsArray = [];

    availableOptionsArray.forEach(el => {
      let availableVariant = this.getVariantJSON().find(variant => {
        const findings = !variant.options.map((option, index) => {
          return option === el[index];
        }).includes(false);
  
        if(findings) return variant;
      });

      availableVariantsArray.push(availableVariant)
    })
    
    return availableVariantsArray;
  }

  addVariantsInfo() {
    const availableVariantsArray = this.getAvailableVariants();
    const multiAddColorContainers = document.querySelectorAll('.multi-add__color-container');
    
    multiAddColorContainers.forEach(container => {
      const containerColor = container.dataset.color;
      const OOSLabel = container.querySelector('.color-swatch__OOS');
      const quantityBtns = container.querySelectorAll('.quantity__button');
      const preorderLabel = container.querySelector('.color-swatch__preorder');

      availableVariantsArray.forEach(variant => {
        if (variant.option1 === containerColor) {
          container.setAttribute('variant-id', variant.id);
          container.setAttribute('available-quantity', variant.inventory_quantity);
          
          if (variant.inventory_quantity < 1) {
            OOSLabel.classList.remove('hidden');
            quantityBtns.forEach(btn => btn.classList.add('disabled'));
            preorderLabel.classList.add('hidden');
          } else {
            OOSLabel.classList.add('hidden');
            quantityBtns.forEach(btn => btn.classList.remove('disabled'));
            if (container.hasAttribute('data-preorder')) preorderLabel.classList.remove('hidden');
          }
        }
      })
    })
  }

  resetQuantity() {
    const allQuantityInputs = document.querySelectorAll('.multi-add__quantity-input');
    const counter = document.querySelector('.multi-add__counter .selected-counter');
    const multiAddAddToCartBtn = document.querySelector('.multi-add-add-to-cart');
    allQuantityInputs.forEach(input => input.value = 0);
    counter.textContent = 0;
    multiAddAddToCartBtn.innerHTML = 'Select Colors';
    multiAddAddToCartBtn.classList.add('disabled');
  }
}

customElements.define('variant-radios', VariantRadios);
// ==================== End VariantRadios Class ====================

// ==================== Start Upsell Popup ====================
class UpsellPopup extends HTMLElement {
  constructor() {
    super();
    this.addToCartBtns = this.querySelectorAll('.upsell-popup__add-to-cart');
    this.headers = this.querySelectorAll('.upsell-popup__header');
    this.price = this.querySelector('.upsell-popup__price');
    this.shopNowBtn = this.querySelector('.upsell-popup__shop');

    document.addEventListener('DOMContentLoaded', this.updateUpsellInfo.bind(this));
    this.addEventListener('click', this.onUpsellPopupClick.bind(this));
    window.addEventListener('keydown', this.onKeydownClick.bind(this));
    this.addToCartBtns.forEach(btn => {
      btn.addEventListener('click', this.onAddToCartBtnClick.bind(this));
    })
    this.shopNowBtn.addEventListener('click', this.onShopNowBtnClick.bind(this));
  }

  updateUpsellInfo() {
    const bundleBuilderSavings = document.querySelector('.bundle-builder__savings-message');

    // 1. Header
    this.headers.forEach(header => header.textContent = bundleBuilderSavings.dataset.upsellHeader);

    // 2. Price
    this.price.textContent = bundleBuilderSavings.dataset.upsellPrice;
  }

  openUpsellPopup() {
    this.classList.remove('hidden');
  }

  closeUpsellPopup() {
    this.classList.add('hidden');
  }

  onUpsellPopupClick(e) {
    if (e.target === this){ 
      this.closeUpsellPopup();
      updateCart();
    }
  }

  onKeydownClick(e) {
    if (e.key === 'Escape') {
      if (!this.classList.contains('hidden')) updateCart();
      this.closeUpsellPopup();
    }
  }

  onAddToCartBtnClick() {
    this.closeUpsellPopup();
    updateCart();
  }

  onShopNowBtnClick() {
    const packSelector = document.querySelector('.singles-and-packs__btn[data-type="packs"]');
    
    this.closeUpsellPopup();
    packSelector.click();
  }
}

customElements.define('upsell-popup', UpsellPopup);
// ==================== End Upsell Popup ====================

// ==================== Start Form Add to Cart Button ====================
// ===== Start Helper Functions =====
const updateCart = function() {
  const cart = document.querySelector('cart-drawer');
  const form = document.querySelector('.product-form #product-form');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(form);
  if (cart) {
    formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
  .then((response) => response.json())
  .then((response) => {
    cart.renderContents(response);
    cart.openCloseCart();
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {
    if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
  });
}
// ===== End Helper Functions =====

const addToCartBtnFunction = function() {
  const addToCartBtn = document.querySelector('.product-form__cta .add-to-cart-button');
  const upsellPopup = document.querySelector('.upsell-popup');
  
  if (!addToCartBtn) return;

  addToCartBtn.addEventListener('click', function(e) {
    e.preventDefault();
  
    if (upsellPopup) { 
      // Check Cookie 
      const cookieName = `upsellPopup-${document.querySelector('.main-product').dataset.handle}`;
      const upsellPopupCookie = getCookie(cookieName);
  
      if (upsellPopupCookie) {
        // upsellPopupCookie = True, means the user already saw it
        // Then add to cart
        updateCart();
      } else {
        // 1- Open upsell popup
        upsellPopup.openUpsellPopup()
        // 2- Update Cookies
        setCookie(cookieName, true, 1);
      }
  
    } else {
      updateCart();
    }
  })
}

document.addEventListener('DOMContentLoaded', addToCartBtnFunction)
// ==================== End Form Add to Cart Button ====================

// ==================== Start Check Unavailable options on load ====================
// Helper Function
const checkSizesAndInseamOnLoad = function(sizeInputs, inseamInputs, variant, selectedColorVariants) {
  // ===== First ===== Disable Size Option if all Inseams are not available
  sizeInputs.forEach((inputSize) => {
    if (variant.option2 === inputSize.value) inputSize.setAttribute('data-counter', `${Number(inputSize.getAttribute('data-counter')) + 1}`);

    // If the 'data-counter' value = the number of Inseam Inputs, means all inseams are not available for this size
    // We can now disable this size
    if (Number(inputSize.getAttribute('data-counter')) ===  inseamInputs.length) inputSize.classList.add('disabled')
  })

  // ===== Second ===== Disable OOS Inseam Options
  // 1- Get Current Checked Size
  const currentSize = document.querySelector('.product-form input[option="Size"][checked]');

  // 2- Get all variants with the same checked size
  // 3- If variant is not available, disable the inseam option
  selectedColorVariants.forEach(el => {
    if (el.option2 === currentSize.value && !el.available) {
      inseamInputs.forEach((inputInseam) => {
        if (el.option3 === inputInseam.value) inputInseam.classList.add('disabled')
      })
    }
  })
}

const checkAvailableOptionsOnLoad = function() {
  const forms = document.querySelectorAll('.product-form:not(.multi-add)');

  forms.forEach(form => {
    const productHandle = form.getAttribute('data-handle');
    const url = `/products/${productHandle}.js`;
    const selectedColor = form.querySelector('.option-heading__current-color');
    let selectedColorVariants = [];
    const inseamInputs = form.querySelectorAll('input[option="Inseam"]');
    const sizeInputs = form.querySelectorAll('input[option="Size"]');
    const notifyMeLink = document.querySelector('.info__notify-me');
  
    if (!selectedColor) return;

    // Product API
    fetch(url)
    .then(response => response.json())
    .then(data => {
      data.variants.forEach(variant => {
        if (variant.option1 === selectedColor.textContent) selectedColorVariants.push(variant);
      })
  
      // Add 'disabled' class to out of stock options
      selectedColorVariants.forEach(variant => {
        if (!variant.available) {
  
          // ========== If Size Only ==========
          if (variant.option2 && !variant.option3) {
            sizeInputs.forEach(input => {
              if (variant.option2 === input.value) input.classList.add('disabled');
            })
          }
  
          // ========== If Size & Inseam ==========
          if((variant.option2 && variant.option3)) checkSizesAndInseamOnLoad(sizeInputs, inseamInputs, variant, selectedColorVariants)
        }
      });

      // Notify Me Link - If at lease there's one variant OOS
      if (selectedColorVariants.some(variant => !variant.available)) {
        if (notifyMeLink) notifyMeLink.classList.add('active');
      }
    })
  })
}
checkAvailableOptionsOnLoad();
// ==================== End Check Unavailable options on load ====================

// ==================== Start Model Info ====================
const modelInfoMobile = function() {
  const allModelInfo = document.querySelectorAll('.model-info--mobile');
  allModelInfo.forEach(el => {
    const modelInfoContainer = el.querySelector('.model-info-inner');
    const modelInfoTitle = el.querySelector('.model-info__title');
    const customerImagesBtns = document.querySelectorAll('.customer-images-btn');

    el.addEventListener('click', function() {
      // 1- Toggle Title
      modelInfoTitle.classList.toggle('hidden');

      // 2- Adjust width
      if (modelInfoTitle.classList.contains('hidden')) modelInfoContainer.style.display = 'block';
      else modelInfoContainer.style.display = 'none';

      // 3- Show/Hide Customer Image Button
      if (modelInfoTitle.classList.contains('hidden')) {
        customerImagesBtns.forEach(btn => btn.classList.add('hidden'));
      } else  {
        customerImagesBtns.forEach(btn => btn.classList.remove('hidden'));
      }
    })
  })
}
modelInfoMobile();
// ==================== End Model Info ====================

// ==================== Start Related Bundles ====================
class RelatedBundles extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector('.related-bundles__header');
    this.allSavings = this.querySelectorAll('.bundle-option__saving');
    this.savingUpTo = this.querySelector('.related-bundles__up-to');

    this.header.addEventListener('click', this.onHeaderClick.bind(this));
    window.addEventListener('resize', this.adjustHeight.bind(this));
    document.addEventListener('DOMContentLoaded', this.highestSavings.bind(this));
  }

  onHeaderClick() {
    // 1. 'active' class
    this.classList.toggle('active');

    // 2. Open or close
    this.adjustHeight()
  }

  adjustHeight() {
    const content = this.querySelector('.related-bundles__content');
    const contentContainer = this.querySelector('.related-bundles__content-container');

    if (this.classList.contains('active')) content.style.maxHeight = getComputedStyle(contentContainer).height;
    else content.style.maxHeight = 0;
  }

  highestSavings() {
    const highestSavings = [...this.allSavings].map(saving => parseInt(saving.textContent.trim().match(/\d+/)[0])).reduce((prev, cur) =>  prev > cur ? prev : cur);

    this.savingUpTo.textContent = `Save up to ${this.savingUpTo.dataset.currency}${highestSavings}`;
  }
}

customElements.define('related-bundles', RelatedBundles);
// ==================== End Related Bundles ====================

// ==================== Start Product Tabs ====================
const productTabsFunction = function() {
  const productTabs = document.querySelectorAll('.product-tab');
  const productTabsHeadings = document.querySelectorAll('.product-tab__heading');
  
  productTabsHeadings.forEach(heading => {
    heading.addEventListener('click', function() {
      const thisTab = heading.closest('.product-tab');
      const productTabContainer = thisTab.querySelector('.product-tab__content-container');
      const productTabHeight = getComputedStyle(productTabContainer.querySelector('.product-tab__content')).height;
  
      // 1) Active class
      if (thisTab.classList.contains('active')) {
        thisTab.classList.remove('active');
      } else {
        productTabs.forEach(el => el.classList.remove('active'));
        thisTab.classList.add('active');
      }
  
      // 2) Content Animation
      if (thisTab.classList.contains('active')) {
        // Close all Tabs
        productTabs.forEach(el => el.querySelector('.product-tab__content-container').style.maxHeight = 0);
        // Open this tab
        productTabContainer.style.maxHeight = productTabHeight;
      } else {
        // Close this tab
        productTabContainer.style.maxHeight = 0;
      }
    })
  })
}

const adjustActiveProductTabHeight = function() {
  const productTabs = [...document.querySelectorAll('.product-tab')];
  const [activeProductTab] = productTabs.filter(tab => tab.classList.contains('active'));
  if (!activeProductTab) return;
  const activeProductTabContainer = activeProductTab.querySelector('.product-tab__content-container');
  const activeProductTabHeight = getComputedStyle(activeProductTabContainer.querySelector('.product-tab__content')).height;
  
  activeProductTabContainer.style.maxHeight = activeProductTabHeight;
}

// Adjust Features tab Height on load
const adjustFeaturesTabHeightOnLoad = function() {
  const featuredTabContainer = document.querySelector('.tab-features .product-tab__content-container');
  if (!featuredTabContainer) return;
  const featuredTabHeight = getComputedStyle(featuredTabContainer.querySelector('.product-tab__content')).height;

  featuredTabContainer.style.maxHeight = featuredTabHeight;
}

// The Fit
const checkTheFitContent = function() {
  const theFit = document.querySelector('.tab-the-fit');
  const theFitContent = theFit.querySelector('.product-tab__content');

  if (theFitContent.textContent.trim()) theFit.classList.remove('hidden');
}

productTabsFunction();
adjustFeaturesTabHeightOnLoad();
checkTheFitContent();
adjustActiveProductTabHeight();
// ==================== End Product Tabs ====================

// ==================== Start Learn More Scroll ====================
const learnMoreFunction = function() {
  const descriptionLearnMore = document.querySelector('.product-description--learn-more');
  if (!descriptionLearnMore) return;
  descriptionLearnMore.addEventListener('click', function() {
    const headerHeigt = parseInt(getComputedStyle(document.querySelector('.mega-sticky-header')).height);
    const productNavHeight = document.querySelector('.sticky-product-nav') ? parseInt(getComputedStyle(document.querySelector('.sticky-product-nav')).height) : 0;
    const topOffset = headerHeigt + productNavHeight;
    const benefitsSection = document.querySelector('.section-product-benefits');
    const mixedBundlesSection = document.querySelector('.mixed-bundles');
    const iconWoolSection = document.querySelector('#product-wool-icons');
  
    if (benefitsSection) {
      document.body.scrollTop = benefitsSection.offsetTop - topOffset;
      document.documentElement.scrollTop = benefitsSection.offsetTop - topOffset;
    } else if (mixedBundlesSection) {
      document.body.scrollTop = mixedBundlesSection.offsetTop - topOffset;
      document.documentElement.scrollTop = mixedBundlesSection.offsetTop - topOffset;
    } else if (iconWoolSection) {
      document.body.scrollTop = iconWoolSection.offsetTop - topOffset;
      document.documentElement.scrollTop = iconWoolSection.offsetTop - topOffset;
    }
  })
}
document.addEventListener('DOMContentLoaded', learnMoreFunction);
// ==================== End Learn More Scroll ====================

// ==================== Start Preorder Function ====================
const preorderFunction = function() {
  const preorderBtn = document.querySelector('.pre-order-button');
  const preorderAddToCartBtn = document.querySelector('.preorder-confirmation__add-to-cart');
  const preorderPopup = document.querySelector('.preorder-confirmation');
  const preorderClose = document.querySelector('.preorder-confirmation__close');

  if (!preorderBtn) return;

  const openPreorderConfirmation = function() {
    preorderPopup.classList.remove('hidden');
    document.body.style.overflow = "hidden";
  }

  const closePreorderConfirmation = function() {
    preorderPopup.classList.add('hidden');
    document.body.style.overflow = "auto";
  }

  // Open
  preorderBtn.addEventListener('click', function(e) {
    e.preventDefault();
    openPreorderConfirmation();
  });

  // Close
  preorderClose.addEventListener('click', closePreorderConfirmation);
  preorderPopup.addEventListener('click', function(e) {
    if (e.target === this) closePreorderConfirmation();
  })
  window.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closePreorderConfirmation();
  });

  // Add to cart
  preorderAddToCartBtn.addEventListener('click', function(e) {
    e.preventDefault();
    closePreorderConfirmation();
    updateCart();
  })
}

document.addEventListener('DOMContentLoaded', preorderFunction);
// ==================== End Preorder Function ====================

// ==================== Start Image Zoom ====================
const featuredImagesZoom = function() {
  // Drift settings for non touch screens
  const driftImgs = [...document.querySelectorAll('.drift-img')];
  driftImgs.map(img => {
    const pane = img.closest('.keen-slider__slide');
    new Drift(img, {
      paneContainer: pane,
      zoomFactor: 4,
      inlinePane: 100,
      touchDelay: 500
    });
  });

  // Zoom functionality
  // A) Non touch Screens - Drift
  const featuredImages = document.querySelectorAll('.product-media__gallery .media-container.type-image');
  featuredImages.forEach(img => {
    img.addEventListener('click', function() {
      const touch = matchMedia('(hover: none)').matches;
      if(!touch) img.classList.toggle('zoom-active');
    })
    

    // Show Tip for touch screens
    img.addEventListener('touchstart', function() {
      const touchScreenZoomTips = document.querySelectorAll('.touch-screen-tool-tip');

      touchScreenZoomTips.forEach(el => {
        el.style.display = 'block';
        el.classList.add('active-animation');

        setTimeout(() => {
          el.style.display = 'none';
          el.classList.remove('active-animation');
        }, 5000);

        img.addEventListener('touchmove', function() {
          el.style.display = 'none';
          el.classList.remove('active-animation');
        })
      })
    })
  })

  // B) Touch screens - Pinch
  const pinchZoomWrappers = document.querySelectorAll('.pinch-zoom');
  pinchZoomWrappers.forEach(el => {
    let pz = new PinchZoom(el, {
      tapZoomFactor: 3,
      minZoom: 0.9,
      draggableUnzoomed: false,
      onZoomStart: function(){
        const touchScreenZoomTips = document.querySelectorAll('.touch-screen-tool-tip');
        touchScreenZoomTips.forEach(el => el.classList.add('hidden'));
      },
      onDoubleTap: function() {
        const touchScreenZoomTips = document.querySelectorAll('.touch-screen-tool-tip');
        touchScreenZoomTips.forEach(el => el.classList.add('hidden'));
      }
    });
  })
}
document.addEventListener('DOMContentLoaded', featuredImagesZoom);
// ==================== End Image Zoom ====================

// ==================== Start Sticky Add to Cart Button ====================
const stickATC = document.querySelector('.sticky-add-to-cart');

const stickATCFunction = function() {
  if (window.innerWidth < 750) {
    const mainProductSectionHeight = parseInt(getComputedStyle(document.querySelector('#main-product')).height);
    if (document.body.scrollTop > mainProductSectionHeight || document.documentElement.scrollTop > mainProductSectionHeight) {
      stickATC.style.display = "block";
      document.body.style.paddingBottom = '78px';
      document.documentElement.style.paddingBottom = '78px';
    } else {
      stickATC.style.display = "none";
      document.body.style.paddingBottom = 0;
      document.documentElement.style.paddingBottom = 0;
    }
  } else {
    stickATC.style.display = "none";
    document.body.style.paddingBottom = 0;
    document.documentElement.style.paddingBottom = 0;
  }
}

window.addEventListener('scroll', stickATCFunction)
window.addEventListener('resize', stickATCFunction)

stickATC.addEventListener('click', function(e) {
  e.preventDefault();
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})
// ==================== End Sticky Add to Cart Button ====================

// ==================== Start Shipping & Returns Modal ====================
// Open & Close Shipping & Returns Modal
const shippingReturnsBtns = document.querySelectorAll('.shipping-tab');

const shippingReturnsFunction = function() {
  if (shippingReturnsBtns.length < 1) return;
  const shippingReturnsPopup = document.querySelector('.shipping-returns-popup');
  const shippingReturnsClose = document.querySelector('.shipping-returns-popup__close');

  const openSizeGuideModal = function() {
    shippingReturnsPopup.classList.remove('hidden');
    document.body.style.overflow = "hidden";
  }

  const closeSizeGuideModal = function() {
    shippingReturnsPopup.classList.add('hidden');
    document.body.style.overflow = "auto";
  }

  // Open Size Guide 
  shippingReturnsBtns.forEach(btn => btn.addEventListener('click', openSizeGuideModal));

  // Close Fit
  shippingReturnsClose.addEventListener('click', closeSizeGuideModal);
  shippingReturnsPopup.addEventListener('click', function(e) {
    if (e.target === this) closeSizeGuideModal();
  })
  window.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSizeGuideModal();
  });
}

document.addEventListener('DOMContentLoaded', shippingReturnsFunction);
// ==================== End Shipping & Returns Modal ====================

// ==================== Start hide BIS hidden options ====================
const hideBIShiddenOptions = function() {
  const bisBtn = document.querySelector('.klaviyo-bis-trigger');
  if (!bisBtn) return;
  bisBtn.addEventListener('click', function() {
    setTimeout(() => {
      const iframe = document.querySelector('#klaviyo-bis-iframe');
      const doc = iframe.contentDocument ?
                  iframe.contentDocument :
                  (iframe.contentWindow ? iframe.contentWindow.document : iframe.document);
      const options = doc.querySelectorAll('#klaviyo-bis-modal select option');
      options.forEach(option => {
        if (option.textContent.includes('_')) option.remove();
      })
    }, 500);
  })
}

document.addEventListener('DOMContentLoaded', hideBIShiddenOptions);
// ==================== End hide BIS hidden options ====================

// ==================== Start Select a size ====================
const allSizeLabels = document.querySelectorAll('.product-form__option-size .product-form__button-label');
allSizeLabels.forEach(sizeLabel => {
  sizeLabel.addEventListener('click', function() {
    const isBundleBuilder = this.closest('.product-form').classList.contains('product-form--bundle-builder') ? true : false;

    if (!isBundleBuilder) {
      if (!this.classList.contains('active')) {
        const relatedInput = document.querySelector(`input[id="${this.getAttribute('for')}"]`);
        const variantRadios = document.querySelector('variant-radios');
  
        // 1 - Add Active class to this label
        allSizeLabels.forEach(el => el.classList.remove('active'));
        this.classList.add('active');
        
        // 2- Add product-form--size-selected class to the product form
        this.closest('.product-form').classList.add('product-form--size-selected');
  
        // 3- OnVariantChange Function
        if (relatedInput.hasAttribute('checked')) {
          variantRadios.onVariantChange();
        } 
      }
    }
  })
})

const selectASizeBtnClick = function() {
  const btn = document.querySelector('.select-size-button');
  btn?.addEventListener('click', (e) => {
    const addToCartEl = btn.querySelector('.select-size-button__add-to-cart');
    const selectASizeEl = btn.querySelector('.select-size-button__select-a-size');
    e.preventDefault();
    addToCartEl.style.display = 'none';
    selectASizeEl.style.display = 'block';
  })
}
document.addEventListener('DOMContentLoaded', selectASizeBtnClick);
// ==================== End Select a size ====================

// ==================== Start UGC Video ====================
const ugcVideoCards = document.querySelectorAll('.ugc-videos__video-card');
ugcVideoCards.forEach(card => {
  card.addEventListener('click', function() {
    const ugcMainVideo = this.closest('.ugc-videos__video-card-container').querySelector('.video-card__main');

    // 1- Full Screen
    ugcMainVideo.play();
    ugcMainVideo.requestFullscreen();

    // 2- Pause the video
    ugcMainVideo.addEventListener('fullscreenchange', function() {
      if (!document.fullscreenElement) {
        ugcMainVideo.pause();
      }
    })
  })
})
// ==================== End UGC Video ====================

// ==================== Start Product Dimensions ====================
const productDimensions = function() {
  const measurementsBtn =  document.querySelector('.measurements-btn');
  const clothingMeasurements = document.querySelector('.clothing-measurements');
  if (!measurementsBtn) return;
  measurementsBtn.addEventListener('click', (e) => {
    e.preventDefault();

    // Open Size Guide Modal
    if (sizeGuidePopup) openSizeGuideModal(sizeGuidePopup);

    // Scroll to Clothing Measurements
    if (clothingMeasurements) clothingMeasurements.scrollIntoView({ behavior: "smooth"});
  })
}

// Init on load
document.addEventListener('DOMContentLoaded', productDimensions);
// ==================== End Product Dimensions ====================

// ==================== Start Customer Images Button ====================
const customerImgesFunction = function() {
  const customerImagesSection = document.querySelector('#customer-images');
  const customerImagesBtns = document.querySelectorAll('.customer-images-btn');

  if (customerImagesSection) {
    customerImagesBtns.forEach(btn => {
      // 1- Show Customer Images Button
      btn.style.display = 'block'

      // 2- Click Event, Scroll to Customer Images Section
      btn.addEventListener('click', function(e) {
        const headerHeigt = parseInt(getComputedStyle(document.querySelector('.mega-sticky-header')).height);
        const productNavHeight = parseInt(getComputedStyle(document.querySelector('.sticky-product-nav')).height);
        const topOffset = headerHeigt + productNavHeight;

        e.preventDefault();

        document.body.scrollTop = customerImagesSection.offsetTop - topOffset + 1;
        document.documentElement.scrollTop = customerImagesSection.offsetTop - topOffset + 1;
      })
    });
  }
}
// document.addEventListener('DOMContentLoaded', customerImgesFunction);
// ==================== End Customer Images Button ====================

// ==================== Start Show Tall/Petite Klaviyo Popups ====================
document.querySelector('.klaviyo-btn--tall-mobile')?.addEventListener('click', function (e){
  e.preventDefault();
  window._klOnsite = window._klOnsite || []; 
  window._klOnsite.push(['openForm', 'UujAf9']);
});
document.querySelector('.klaviyo-btn--tall-desktop')?.addEventListener('click', function (e){
  e.preventDefault();
  window._klOnsite = window._klOnsite || []; 
  window._klOnsite.push(['openForm', 'TL9hRu']);
});

document.querySelector('.klaviyo-btn--petite-mobile')?.addEventListener('click', function (e){
  e.preventDefault();
  window._klOnsite = window._klOnsite || []; 
  window._klOnsite.push(['openForm', 'RGFxX9']);
});
document.querySelector('.klaviyo-btn--petite-desktop')?.addEventListener('click', function (e){
  e.preventDefault();
  window._klOnsite = window._klOnsite || []; 
  window._klOnsite.push(['openForm', 'V34hTz']);
});

// ==================== End Show Tall/Petite Klaviyo Popups ====================

// ==================== Start Micron Chart ====================
const micronChart = function() {
  const progress = document.querySelector('.micron-chart__progress');
  const progressValue = document.querySelector('.micron-chart__progress-value');
  if (!progress) return;
  const progressWidth = parseInt(getComputedStyle(progress).width);
  const progressValueWidth = parseInt(getComputedStyle(progressValue).width);
  const remainingProgressWidth = progressWidth - progressValueWidth;
  const percentage = progressValue.dataset.percentage;
  const pxToMove = (remainingProgressWidth * percentage) / 100;

  progressValue.style.left = `${pxToMove}px`;
}

document.addEventListener('DOMContentLoaded', micronChart);
window.addEventListener('resize', micronChart);
// ==================== End Micron Chart ====================

// ==================== Start Micron Modal ====================
const micronModal = document.querySelector('.micron-modal');

const openMicronModal = (micronModal) => {
  micronModal.classList.remove('hidden');
  document.body.classList.add('micron-modal-opened');
}

const closeMicronModal = (micronModal) => {
  micronModal.classList.add('hidden');
  document.body.classList.remove('micron-modal-opened');
}

const micronModalFunction = () => {
  if (!micronModal) return;
  const iconOpen = document.querySelector('.micron-list-item .icon-question-mark');
  const iconClose = micronModal.querySelector('.icon-close');

  // Open
  iconOpen.addEventListener('click', () => openMicronModal(micronModal));

  // Close
  iconClose.addEventListener('click', () => closeMicronModal(micronModal));
  micronModal.addEventListener('click', function(e) {if (e.target === this) closeMicronModal(micronModal)});
  window.addEventListener('keydown', e => {if (e.key === 'Escape') closeMicronModal(micronModal)});
}

document.addEventListener('DOMContentLoaded', () => {
  if (micronModal) micronModalFunction()
});
// ==================== End Micron Modal ====================

// ==================== Start singles and packs buttons ====================
const singleAndPacksBtns = function() {
  const btns = document.querySelectorAll('.singles-and-packs__btn');

  btns.forEach(btn => {
    btn.addEventListener('click', function() {
      if (btn.classList.contains('active')) return;

      const btnBg = document.querySelector('.singles-and-packs__btn-background');
      const productFormContainer = document.querySelector('.singles-and-packs__product-form');
      const bundleBuilderContainer = document.querySelector('.singles-and-packs__bundle-builder');
      const savingsEls = document.querySelectorAll('.singles-and-packs__savings');
      const singlePrice = document.querySelectorAll('.product-price');
      const packPrice = document.querySelectorAll('.pack-price');
      const singleVariantRadiosEl = document.querySelector('.singles-and-packs__product-form variant-radios');

      // If packs
      if (btn.dataset.type === 'packs') {
        // 1. active class
        btns.forEach(el => el.classList.remove('active'));
        btn.classList.add('active');

        // 2. Background animation
        btnBg.classList.remove('active-singles');
        btnBg.classList.add('active-packs');

        // 3. Show bundle builder
        productFormContainer.classList.add('hidden');
        bundleBuilderContainer.classList.remove('hidden');

        // 4. Hide savings
        savingsEls.forEach(el => el.classList.add('visibility-hidden'));

        // 5. Show pack price
        singlePrice.forEach(price => price.classList.add('hidden'));
        packPrice.forEach(price => price.classList.remove('hidden'));
      }

      // If singels
      if (btn.dataset.type === 'singles') {
        // 1. active class
        btns.forEach(el => el.classList.remove('active'));
        btn.classList.add('active');

        // 2. Background animation
        btnBg.classList.add('active-singles');
        btnBg.classList.remove('active-packs');

        // 3. Show product form
        productFormContainer.classList.remove('hidden');
        bundleBuilderContainer.classList.add('hidden');

        // 4. Show savings
        savingsEls.forEach(el => el.classList.remove('visibility-hidden'));

        // 5. Show product price
        packPrice.forEach(price => price.classList.add('hidden'));
        singlePrice.forEach(price => price.classList.remove('hidden'));

        // 6. Update product info
        singleVariantRadiosEl.getSelectedOptions();
        singleVariantRadiosEl.getVariantJSON();
        singleVariantRadiosEl.getSelectedVariant();
        singleVariantRadiosEl.updateProductInfo();
      }
    })
  })
}

document.addEventListener('DOMContentLoaded', singleAndPacksBtns);
// ==================== End singles and packs switch ====================